/*eslint-disable*/
import React from "react";
import {
  makeStyles,
  Paper,
  Typography,
  Chip,
  Divider,
  Button,
  Avatar,
  Grid,
  Card,
  CardContent,
} from "@material-ui/core";
import BusinessIcon from "@material-ui/icons/Business";
import PersonIcon from "@material-ui/icons/Person";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import BookIcon from "@material-ui/icons/Book";
import HistoryIcon from "@material-ui/icons/History";
import LocalHospitalIcon from "@material-ui/icons/LocalHospital";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  page: { padding: theme.spacing(4) },
  card: {
    padding: theme.spacing(3),
    borderRadius: 12,
    boxShadow: theme.shadows[3],
    maxWidth: 1100,
    margin: "0 auto",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  chip: { fontWeight: 600 },
  stepRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2.2),
  },
  avatar: { width: 44, height: 44, fontWeight: 700 },
  stepTitleRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  actionBtn: { textTransform: "none", minWidth: 84 },
  featureCard: {
    height: "100%",
    borderRadius: 12,
    boxShadow: theme.shadows[2],
  },
  featureIcon: {
    fontSize: 28,
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(1),
  },
}));

function Step({ index, title, desc, to }) {
  const classes = useStyles();
  const navigate = useNavigate();
  return (
    <div className={classes.stepRow}>
      <Avatar style={{ backgroundColor: "#059669" }} className={classes.avatar}>
        {index}
      </Avatar>

      <div style={{ flex: 1 }}>
        <div className={classes.stepTitleRow}>
          <Typography variant="subtitle1">{title}</Typography>
          {to ? (
            <Button
              size="small"
              variant="outlined"
              className={classes.actionBtn}
              onClick={() => navigate(to)}
            >
              Open
            </Button>
          ) : null}
        </div>
        <Typography variant="body2" color="textSecondary">
          {desc}
        </Typography>
      </div>
    </div>
  );
}

export default function UserJourneyDoctor() {
  const classes = useStyles();

  const steps = [
    {
      title: "View & Edit Profile",
      desc: "View and edit your profile, contact details, and practice information.",
      to: "/doctorprofile",
    },
    {
      title: "Edit Profile",
      desc: "Update your profile details and settings.",
      to: "/editprofile",
    },
    {
      title: "Calendar & Appointments",
      desc: "View your calendar, manage appointments and clinic bookings.",
      to: "/doctorcalendar",
    },
    {
      title: "Clinic Bookings",
      desc: "Manage your clinic bookings.",
      to: "/clinicbookings",
    },
    {
      title: "Patient Bookings & Consultations",
      desc: "Manage patient bookings, start consultations and record outcomes.",
      to: "/bookings",
    },
    {
      title: "Medical Histories & Notes",
      desc: "Access and update patient histories, notes and prescriptions.",
      to: "/doctortreatmentnotes",
    },
    {
      title: "Referrals",
      desc: "Review referral requests and create/manage outgoing referrals.",
      to: "/doctorrefreq",
    },
    {
      title: "Timeline & Activity",
      desc: "View your activity timeline — consultations, prescriptions, notes.",
      to: "/timeline",
    },
    {
      title: "Practice Admins",
      desc: "Add or manage practice admins (if applicable).",
      to: "/addpracticeadmin",
    },
  ];

  const capabilities = [
    {
      icon: <LocalHospitalIcon className={classes.featureIcon} />,
      title: "Edit Profile & Practice",
      desc: "Update contact details, qualifications and practice settings.",
    },
    {
      icon: <CalendarTodayIcon className={classes.featureIcon} />,
      title: "Manage Calendar",
      desc: "Create, edit and cancel appointments and clinic sessions.",
    },
    {
      icon: <BookIcon className={classes.featureIcon} />,
      title: "Patient Consultations",
      desc: "Open consultations, add notes and prescribe treatment.",
    },
    {
      icon: <HistoryIcon className={classes.featureIcon} />,
      title: "Medical History Access",
      desc: "View and update patient histories and ongoing treatments.",
    },
    {
      icon: <PersonIcon className={classes.featureIcon} />,
      title: "Referrals",
      desc: "Accept, send and track referral requests.",
    },
    {
      icon: <PersonIcon className={classes.featureIcon} />,
      title: "Practice Admins",
      desc: "Grant admin rights to staff who should manage the practice.",
    },
  ];

  return (
    <div className={classes.page}>
      <Paper className={classes.card}>
        <div className={classes.header}>
          <div>
            <Typography variant="h5" gutterBottom>
              <BusinessIcon style={{ verticalAlign: "middle", marginRight: 8 }} />
              Doctor — Help & Quick Actions
            </Typography>
            <Typography variant="body2" color="textSecondary">
              (Doctor) Clinical and practice tools
            </Typography>
          </div>
          <Chip
            label="Doctor"
            className={classes.chip}
            style={{ backgroundColor: "#ECFDF5" }}
          />
        </div>

        {/* Journey Steps */}
        <div>
          {steps.map((s, i) => (
            <Step key={s.title} index={i + 1} title={s.title} desc={s.desc} to={s.to} />
          ))}
        </div>

        <Divider style={{ margin: "20px 0" }} />

        {/* Doctor Capabilities */}
        <Typography variant="h6" gutterBottom>
          Key Doctor Capabilities
        </Typography>
        <Grid container spacing={3}>
          {capabilities.map((f) => (
            <Grid item xs={12} sm={6} md={4} key={f.title}>
              <Card className={classes.featureCard}>
                <CardContent>
                  {f.icon}
                  <Typography variant="subtitle1" gutterBottom>
                    {f.title}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {f.desc}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Paper>
    </div>
  );
}

